/**
 * The sign-in gate, shown when the identity service is on and there is no token.
 */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { beginSignIn, completeSignIn, type IdentityInfo } from '../lib/signin';

export function SignIn({ identity }: { identity: IdentityInfo }) {
  const [error, setError] = useState<string | null>(null);
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0b2635', color: '#fff', padding: 24 }}>
      <div style={{ maxWidth: 420, width: '100%', background: '#fff', color: '#102430', borderRadius: 14, padding: 28 }}>
        <div style={{ fontSize: 20, fontWeight: 700 }}>PTS Compass</div>
        <p style={{ color: '#64757e' }}>CRM and quotations. Sign in with your PTS account; you will be asked for your password and, where set up, your second factor.</p>
        {error ? <p style={{ color: '#b3261e' }}>{error}</p> : null}
        <button className="primary" style={{ width: '100%' }} onClick={() => beginSignIn(identity).catch((e) => setError(String(e.message ?? e)))}>
          Sign in
        </button>
        <p style={{ color: '#64757e', fontSize: '0.85em', marginTop: 16 }}>No account? Ask an administrator to invite you.</p>
      </div>
    </div>
  );
}

/** /auth/callback — swap the code for a token and go home. */
export function AuthCallback({ identity }: { identity: IdentityInfo }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const code = new URLSearchParams(location.search).get('code');
    if (!code) { setError('No sign-in code was returned.'); return; }
    completeSignIn(identity, code).then(() => navigate('/', { replace: true })).catch((e) => setError(String(e.message ?? e)));
  }, [identity, location.search, navigate]);
  return <div style={{ padding: 40 }}>{error ?? 'Signing you in…'}</div>;
}
